import React, { useCallback } from "react";
import { format, isSameYear } from "date-fns";
import { withRouter, RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import { Maybe } from "true-myth";
import styled from "styles/styled_components";

import { trackEvent } from "helpers/analytics";
import { DateFormats } from "helpers/dates";
// import { dateToDateParam } from "helpers/dates";

const StyledWrapper = styled.div`
  padding: ${(props) => props.theme.spacing.small};
`;

const StyledTitle = styled.div`
  color: ${(props) => props.theme.colors.brandGray50};
  font-size: ${(props) => props.theme.text.size.jumbo};
  line-height: ${(props) => props.theme.text.lineHeight.medium};
`;

const StyledSubTitleWrap = styled.div`
  padding-left: ${(props) => props.theme.spacing.smidge};
  & * {
    line-height: ${(props) => props.theme.text.size.largest};
  }
`;

const StyledSubTitle = styled.div`
  color: ${(props) => props.theme.colors.dsGrayMedium};
`;

interface ITitle extends RouteComponentProps {
  dayView: Maybe<Date>;
  startDate: Maybe<Date>;
  endDate: Maybe<Date>;
}

const DAY_VIEW_PARAM_RX = /&?dayView=[^&]*/;

function Title({ dayView, startDate, endDate }: ITitle) {
  const trackWeekLink = useCallback(
    () => trackEvent("View the week (from day view link)"),
    []
  );
  const isWeekView = dayView.isNothing();
  // FIXME: Point to current day, not startDate
  // Will require some logic to switch week range if today is outside range
  // <Link
  //   to={`${location.pathname}${location.search}&dayView=${dateToDateParam(
  //     startDate
  //   ).unwrapOr("")}`}>
  //   Today's Schedule
  // </Link>
  const viewSwitchLink = isWeekView ? null : (
    <Link
      to={`${location.pathname}${location.search.replace(
        DAY_VIEW_PARAM_RX,
        ""
      )}`}
      onClick={trackWeekLink}
    >
      This Week's Schedule
    </Link>
  );

  const subtitle = isWeekView
    ? Maybe.all(startDate, endDate).map(([start, end]) => {
        // When start and end span a year boundary, show year for start format
        const startFormat = isSameYear(start, end)
          ? DateFormats.MONTH_DAY
          : DateFormats.MONTH_DAY_YEAR_LONG;
        const startFormatted = format(start, startFormat);
        const endFormatted = format(end, DateFormats.MONTH_DAY_YEAR_LONG);
        return `${startFormatted} - ${endFormatted}`;
      })
    : dayView.map((day) => format(day, DateFormats.MONTH_DAY_YEAR_LONG));

  return (
    <StyledWrapper>
      <StyledTitle>
        {isWeekView ? "Weekly Schedule" : "Daily Schedule"}
      </StyledTitle>
      <StyledSubTitleWrap>
        <StyledSubTitle>{subtitle.unwrapOr("")}</StyledSubTitle>
        {viewSwitchLink}
      </StyledSubTitleWrap>
    </StyledWrapper>
  );
}

export default withRouter(Title);
